import React, { useCallback, useEffect, useRef, useState } from "react";
import { GridWrapper } from "./style";
import { AgGridReact } from 'ag-grid-react';
// import "ag-grid-enterprise";
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const Index = (props) => {
  const {
    gridOptions,
    gridReady,
    getRowHeight,
    defaultColDef,
    columnDefinitions,
    user_referrals,
    sidebarOpen,
    className,
    rowHeight,
    onSortChange,
    onSelectionChanged,
    rowSelection,
    getRowClass,
    height,
    masterDetail,
    collapse,
    detailCellRenderer,
    onFirstDataRendered,
    getRowNodeId,
    rowId,
    headerHeight,
    whiteSpace,
    getRowStyle,
    domLayout,
    detailRowAutoHeight,
    headerBg,
    getRowId,
    rowClassRules,
    onRowSelected,
    onModelUpdated,
    context,
    containerHeight
  } = props
  const gridContainerRef = useRef(null);
  const frameRef = useRef(null);
  const lastHeightRef = useRef(null);
  const [responsiveHeight, setResponsiveHeight] = useState('');

  const findNearestPagination = useCallback(() => {
    if (!gridContainerRef.current) return null;
    const gridRect = gridContainerRef.current.getBoundingClientRect();
    const gridCenterX = gridRect.left + (gridRect.width / 2);

    const paginationElements = Array.from(document.querySelectorAll('.qb-pagination'));
    let nearestPagination = null;
    let nearestTop = Number.POSITIVE_INFINITY;

    paginationElements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < gridRect.top) return;

      const centerX = rect.left + (rect.width / 2);
      const horizontalDistance = Math.abs(centerX - gridCenterX);
      if (horizontalDistance > Math.max(gridRect.width, 400)) return;

      if (rect.top < nearestTop) {
        nearestTop = rect.top;
        nearestPagination = element;
      }
    });

    return nearestPagination;
  }, []);

  const updateResponsiveHeight = useCallback(() => {
    if (!height || containerHeight || !gridContainerRef.current) return;

    const gridTop = gridContainerRef.current.getBoundingClientRect().top;
    const paginationElement = findNearestPagination();
    const paginationHeight = paginationElement?.getBoundingClientRect?.().height || 0;
    const bottomSpacing = 24;
    const minHeight = 220;
    const availableHeight = Math.floor(window.innerHeight - gridTop - paginationHeight - bottomSpacing);
    const nextHeight = `${Math.max(minHeight, availableHeight)}px`;

    if (lastHeightRef.current !== nextHeight) {
      lastHeightRef.current = nextHeight;
      setResponsiveHeight(nextHeight);
    }
  }, [height, containerHeight, findNearestPagination]);

  const scheduleHeightUpdate = useCallback(() => {
    if (frameRef.current) cancelAnimationFrame(frameRef.current);
    frameRef.current = requestAnimationFrame(() => {
      updateResponsiveHeight();
      frameRef.current = null;
    });
  }, [updateResponsiveHeight]);

  useEffect(() => {
    if (!height || containerHeight) return undefined;
    scheduleHeightUpdate();
    window.addEventListener('resize', scheduleHeightUpdate);

    let resizeObserver;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        scheduleHeightUpdate();
      });

      if (gridContainerRef.current) resizeObserver.observe(gridContainerRef.current);
      const paginationElement = findNearestPagination();
      if (paginationElement) resizeObserver.observe(paginationElement);
      if (document.body) resizeObserver.observe(document.body);
    }

    return () => {
      window.removeEventListener('resize', scheduleHeightUpdate);
      if (resizeObserver) resizeObserver.disconnect();
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [height, containerHeight, findNearestPagination, scheduleHeightUpdate]);

  const resolvedContainerHeight = containerHeight || responsiveHeight;

  return (
    <GridWrapper
      height={height || ''}
      whiteSpace={whiteSpace}
      headerBg={headerBg}
      containerHeight={containerHeight}
    >
      <div
        ref={gridContainerRef}
        className={`${collapse ? ' ag-theme-material' : 'ag-theme-balham'} QB-dataTable ${className}`}
        style={resolvedContainerHeight ? { height: resolvedContainerHeight } : undefined}
      >
        <AgGridReact
          gridOptions={gridOptions}
          reactNext={true}
          onGridReady={gridReady}
          deltaRowDataMode={false}
          getRowHeight={getRowHeight}
          animateRows={true}
          getRowStyle={getRowStyle}
          defaultColDef={defaultColDef}
          columnDefs={columnDefinitions}
          onSortChanged={onSortChange}
          rowData={user_referrals}
          rowHeight={rowHeight}
          headerHeight={headerHeight || 38}
          enableCellTextSelection={true}
          getRowNodeId={getRowNodeId ? getRowNodeId : ({ id }) => id}
          pagination={false}
          sideBar={sidebarOpen ? 'columns' : false}
          enableRangeSelection={true}
          suppressRowClickSelection={true}
          suppressScrollOnNewData={true}
          paginationPageSize={10}
          onSelectionChanged={onSelectionChanged}
          rowSelection={rowSelection}
          getRowClass={getRowClass}
          masterDetail={masterDetail}
          detailCellRenderer={detailCellRenderer}
          detailRowHeight={300}
          rowId={rowId}
          domLayout={domLayout}
          onFirstDataRendered={onFirstDataRendered}
          detailRowAutoHeight={detailRowAutoHeight}
          getRowId={getRowId}
          rowClassRules={rowClassRules}
          onRowSelected={onRowSelected}
          onModelUpdated={onModelUpdated}
          context={context}
        />
      </div>
    </GridWrapper>
  )
};
export default Index;
